import { AutoColumn } from 'components/Column'
import Modal from 'components/Modal'
import Row from 'components/Row'
import React from 'react'
import styled from 'styled-components/macro'
import { CloseIcon, ThemedText } from 'theme'

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.backgroundSurface};
  border-radius: 20px;
  outline: 1px solid ${({ theme }) => theme.backgroundOutline};
  width: 100%;
  padding: 16px;
  overflow-y: scroll;
  max-height: 500px;

  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-thumb {
    width: 3px;
    background: gray;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-track {
  }
`

const HiddenScroll = styled.div`
  border-radius: 20px;
  width: 100%;
  overflow-y: hidden;
  max-height: 500px;
`

interface IModalProps {
  isOpen: boolean
  onDismiss: () => void
}

export const InfoModal = ({ isOpen, onDismiss }: IModalProps) => {
  return (
    <Modal isOpen={isOpen} $scrollOverlay={true} onDismiss={onDismiss} maxHeight={50}>
      <HiddenScroll>
        <Wrapper>
          <AutoColumn gap="sm">
            <Row>
              <Row justify="center" marginLeft="24px">
                <ThemedText.SubHeader>How it works?</ThemedText.SubHeader>
              </Row>
              <CloseIcon onClick={onDismiss} data-testid="confirmation-close-icon" />
            </Row>
            <ul style={{ display: 'flex', flexDirection: 'column', gap: '8px', paddingLeft: '20px' }}>
              <li>
                The incentive program enables liquidity providers to enhance their rewards by staking their V3 liquidity
                positions (NFTs) within the staking contract. Rewards are distributed among all staked positions,
                considering factors such as liquidity amount, staking duration, and the period in which the price stays
                within the specified position&apos;s range. If the price falls out of the range, the position ceases to
                accumulate both fees and staking rewards
              </li>
              <li>
                The initiator establishes the start and end times of the incentive program, along with the vesting
                period, reward token, and total amount of rewards to distribute before the program begins.
              </li>
              <li>
                To participate in an incentive program, you need to have a liquidity position on the corresponding XSwap
                V3 pool. If you don&apos;t see any position on the incentive page, click the button &quot;+New
                position&quot; on the top right. If you have corresponding positions, you will see them at the bottom of
                the page. Click the &quot;Stake&quot; button on the pair that you wish to stake and your NFT will be
                transferred to the staking contract. If the position is active, it will start earning rewards. While
                your position is staked, you will see your current earned rewards, vesting percentage and other
                additional information. To unstake your position, click on the &quot;Unstake&quot; button and both your
                NFT position and the associated rewards will be transferred to your address. There is no way to claim
                rewards separately without unstaking.
              </li>
              <li>
                The vesting period signifies the timeframe within which a position must remain active. If the price
                stays within the staked position&apos;s range for the entire vesting period, the position is eligible to
                claim 100% of the rewards. However, if the price remains within the range for a shorter duration, the
                position can claim a proportional share of the earned rewards, calculated linearly.
              </li>
              <li>
                The APR is contingent on the aggregate staked value, the price of the reward token, and the overall
                rewards allocated for the program. To estimate it, you can use this formula: APR = (rewards_per_second *
                seconds_in_year) / total_value_locked * 100.
              </li>
            </ul>
          </AutoColumn>
        </Wrapper>
      </HiddenScroll>
    </Modal>
  )
}
